const HTML_ESCAPES: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
}

const escapeHtml = (s: string): string => s.replace(/[&<>"']/g, (c) => HTML_ESCAPES[c] ?? c)

const decodeHtml = (s: string): string =>
  s
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&amp;/g, '&')

export function serializeReplyQuoteTag(quoteText: string): string {
  return `<reply-quote>${escapeHtml(quoteText).replace(/\n/g, '<br/>')}</reply-quote>`
}

const REPLY_QUOTE_RE = /^\s*<reply-quote>([\s\S]*?)<\/reply-quote>\s*/
const PENDING_CONTEXT_RE = /<pending-context>[\s\S]*?<\/pending-context>\s*/g

export function parseUserMessageText(raw: string): {
  text: string
  replyQuote?: string
} {
  let working = raw
  let replyQuote: string | undefined

  const match = working.match(REPLY_QUOTE_RE)
  if (match) {
    replyQuote = decodeHtml(match[1] ?? '')
    working = working.replace(REPLY_QUOTE_RE, '')
  }

  working = working.replace(PENDING_CONTEXT_RE, '').trim()

  return { text: working, replyQuote }
}
